export { default } from './WebsiteCard';



// WEBPACK FOOTER //
// ./src/components/organisms/WebsiteCard/index.js